// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__okylG","homeWrapper":"Home_homeWrapper__5JxNc","homeLogo":"Home_homeLogo__-3F3+"};